export enum TaskScheduleType {
  SPECIFIC = 'specific',
  IN_ONE_WEEK = 'inOneWeek',
  IN_TWO_WEEKS = 'inTwoWeeks',
  IN_ONE_MONTH = 'inOneMonth',
  FLEXIBLE = 'flexible',
}
